import { Injectable } from '@angular/core';
import { AppEvents } from '@commoncore/utils/app-events';

@Injectable({
  providedIn: 'root'
})
export class FileOperationsHelperService {

  constructor() { }


  confirmOperation(object){
    AppEvents.globalObservable.next({"type":"confirmOperation","data":object})
  }

  createNewFolder(){
    AppEvents.globalObservable.next({"type":"createNewFolder"})
  }

  confirmShareOperation(object){
    AppEvents.globalObservable.next({"type":"confirmShareOperation","data":object})
  }

  confirmFileOpn(object){
    AppEvents.globalObservable.next({"type":"confirmFileOpn","data":object})
  }

  createNewAlbum(){
    AppEvents.globalObservable.next({"type":"createNewAlbum"})
  }

  closeCreateModal(){
    AppEvents.globalObservable.next({"type":"closeCreateModal"})
  }

  goBackToPreviousScreen(){
    AppEvents.globalObservable.next({"type":"goBackToPreviousScreen"})
  }

  validateBeforeCreatingAlbum(object){
    AppEvents.globalObservable.next({"type":"validateBeforeCreatingAlbum","data":object})
  }

  close(){
    AppEvents.globalObservable.next({"type":"close"})
  }

  removeFolderKeys(){
    AppEvents.globalObservable.next({"type":"removeFolderKeys"})
  }

  fetchNestedFoldersData(object){
    AppEvents.globalObservable.next({"type":"fetchNestedFoldersData","data":object})
  }

  fetchNestedFoldersDataForMobile(object){
    AppEvents.globalObservable.next({"type":"fetchNestedFoldersDataForMobile","data":object})
  }

  fetchNestedFolderDataForShared(object){
    AppEvents.globalObservable.next({"type":"fetchNestedFolderDataForShared","data":object})
  }

  fetchNestedFolderDataForTeamFolder(object){
    AppEvents.globalObservable.next({"type":"fetchNestedFolderDataForTeamFolder","data":object})
  }

  fetchNestedFolderDataForTeamFolderMobile(object){
    AppEvents.globalObservable.next({"type":"fetchNestedFolderDataForTeamFolderMobile","data":object})
  }

  fetchNestedFolderDataForMobileShared(object){
    AppEvents.globalObservable.next({"type":"fetchNestedFolderDataForMobileShared","data":object})
  }

  validateBeforeCreatingFolder(object){
    AppEvents.globalObservable.next({"type":"validateBeforeCreatingFolder","data":object})
  }

  createFolderAndMove(){
    AppEvents.globalObservable.next({"type":"createFolderAndMove"})
  }

  createFolderAndCopy(){
    AppEvents.globalObservable.next({"type":"createFolderAndCopy"})
  }


}
